import request from '@/utils/request'


// 查询视频-信息列表
export function listVideo(query) {
  return request({
    url: '/platform/video/list',
    method: 'get',
    params: query
  })
}

// 查询视频-信息分页
export function pageVideo(query) {
  return request({
    url: '/platform/video/page',
    method: 'get',
    params: query
  })
}

// 查询视频-信息详细
export function getVideo(data) {
  return request({
    url: '/platform/video/detail',
    method: 'get',
    params: data
  })
}

// 新增视频-信息
export function addVideo(data) {
  return request({
    url: '/platform/video/add',
    method: 'post',
    data: data
  })
}

// 修改视频-信息
export function updateVideo(data) {
  return request({
    url: '/platform/video/apply',
    method: 'post',
    data: data
  })
}

// 删除视频-信息
export function delVideo(data) {
  return request({
    url: '/platform/video/delete',
    method: 'post',
    data: data
  })
}
